app.controller('OrganizationalUnitsIndexController', [
    '$scope', '$uibModal', 'OrganizationalUnit', '$state', 'ConfirmModal', 'usSpinnerService', 'toastr', '$stateParams',
    function ($scope, $uibModal, OrganizationalUnit, $state, ConfirmModal, usSpinnerService, toastr, $stateParams) {
        $scope.treeOptions = {
            dropped: function (event) {
                var unit = event.source.nodeScope.$modelValue;
                var newParent = event.dest.nodesScope.$parent.$modelValue;

                if (unit.parent === newParent._id) return;

                OrganizationalUnit.changeParent(unit._id, newParent._id)
                    .then(function () {
                        fetchUnits();
                    });
            }
        };
        $scope.expandedNodes = JSON.parse(sessionStorage.getItem('expandedNodes') || "[]");

        function fetchUnits() {
            usSpinnerService.spin('root');
            return OrganizationalUnit.getAll()
                .then(function (roots) {

                    roots.forEach(function (item) {
                        item.children = [];
                        item.parentNode = item.parent;
                        item.expanded = $scope.expandedNodes.indexOf(item._id) > -1
                    });
                    $scope.unitsTree = list_to_tree(roots) || [];
                    usSpinnerService.stop('root');
                });
        }

        fetchUnits();



        $scope.toggleChildren = function (unit) {
            unit.expanded = !unit.expanded;
            sessionStorage.setItem('expandedNodes', JSON.stringify(getExpandedNodes()));
        };

        $scope.addRootOrganization = function () {
            $uibModal.open({
                controller: 'OrganizationalUnitAddController',
                templateUrl: _pb + 'employee/organizational-units/organizational-unit-add.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    params: {
                        parentId: null
                    }
                }
            }).result
                .then(function () {
                    fetchUnits();
                    toastr.success('ორგანიზაციული ერთეული დაემატა');
                }, function () {
                });
        };

        $scope.addChild = function (unit, e) {
            e.stopPropagation();
            $uibModal.open({
                controller: 'OrganizationalUnitAddController',
                templateUrl: _pb + 'employee/organizational-units/organizational-unit-add.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: {
                        parentId: unit._id
                    }
                }
            }).result
                .then(function () {
                    fetchUnits();
                    toastr.success('ორგანიზაციული ერთეული დაემატა');
                }, function () {
                });
        };

        $scope.editUnitName = function (unit, e) {
            e.stopPropagation();
            $uibModal.open({
                controller: 'OrganizationalUnitEditController',
                templateUrl: _pb + 'employee/organizational-units/organizational-unit-add.html',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    params: {
                        id: unit._id,
                        name: unit.name,
                        faculties: unit.faculties
                    }
                }
            }).result
                .then(function () {
                    toastr.success('ორგანიზაციული ერთეულის სახელი შეიცვალა');
                    fetchUnits();
                }, function () {
                });
        };

        $scope.deleteUnit = function (unit, e) {
            e.stopPropagation();
            ConfirmModal.show({
                title: "ორგანიზაციული ერთეულის წაშლა",
                message: 'გსურთ "' + unit.name + '" წაიშალოს ორგანიზაციული ერთეულებიდან?'
            }).result.then(function () {
                OrganizationalUnit.delete(unit._id)
                    .then(function () {
                        toastr.success('ორგანიზაციული ერთეული წაიშალა');
                        fetchUnits();
                    });
            });
        };

        $scope.goToState = function (state, unit) {
            $state.go(state, { unit: unit._id });
        };


        function list_to_tree(list) {
            var map = {}, node, roots = [], i;
            for (i = 0; i < list.length; i += 1) {
                map[list[i]._id] = i; // initialize the map
                list[i].children = []; // initialize the children
            }


            for (i = 0; i < list.length; i += 1) {
                node = list[i];
                if (node.parent) {
                    // if you have dangling branches check that map[node.parentId] exists
                    list[map[node.parent]].children.push(node);
                } else {
                    roots.push(node);
                }
            }

            return roots;
        }

        function getExpandedNodes(n) {
            var node = n || $scope.unitsTree[0];
            var expanded = [];
            if (node.expanded)
                expanded.push(node._id);
            if (node.children.length)
                node.children.forEach(function (childNode) {
                    var childExpanded = getExpandedNodes(childNode);
                    expanded = expanded.concat(childExpanded);
                });
            return expanded;
        }

    }]);
